import { Component, Input, OnInit } from "@angular/core";
import { CommentsService, TenantComment } from "./comments-service.service";
import { MatCard, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput, MatHint } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatButton, MatIconButton } from '@angular/material/button';
import { DatePipe } from '@angular/common';
import { MarkdownComponent } from 'ngx-markdown';
import { MatIcon } from '@angular/material/icon';
import { TimeagoModule } from 'ngx-timeago';

@Component({
    selector: "aw-tenant-comments",
    templateUrl: "./tenant-comments.component.html",
    styleUrls: ["./tenant-comments.component.less"],
    imports: [MatCard, MatCardTitle, MatCardSubtitle, MatCardContent, FormsModule, MatFormField, MatLabel, MatInput, CdkTextareaAutosize, MatHint, MatButton, MarkdownComponent, MatIconButton, MatIcon, DatePipe, TimeagoModule]
})
export class TenantCommentsComponent implements OnInit {
  private _clientId: string;

  public get clientId(): string {
    return this._clientId;
  }
  @Input()
  public set clientId(value: string) {
    this._clientId = value;
    this.getComments();
  }
  comments: TenantComment[];
  constructor(private readonly commentsService: CommentsService) {}

  ngOnInit(): void {
    this.getComments();
  }

  getComments() {
    this.commentsService
      .getCommentsForTenant(this.clientId)
      .subscribe((comments) => (this.comments = comments));
  }

  submitComment(newComment: HTMLTextAreaElement) {
    this.commentsService
      .submitComment(this.clientId, newComment.value)
      .subscribe(() => {
        this.getComments();
        newComment.value = "";
      });
  }

  deleteComment(comment: TenantComment) {
    this.commentsService
      .deleteComment(comment)
      .subscribe(() => this.getComments());
  }
}
